import { useEffect } from "react";
import { useDispatch } from "react-redux";

import { SeoTags } from "../../components";
import { PublicOffer } from "../../components/info/PublicOfferComponent";
import { setShowSearch } from "../../store/appConfigsSlice";

const PublicOfferPage = () => {
	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(setShowSearch(false));
	}, []);

	return (
		<>
			<SeoTags pageKey="publicOfferPage" />
			<PublicOffer />
		</>
	);
};

export default PublicOfferPage;